import React from 'react'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Row, Col } from 'reactstrap'

import style from './style'

export const SingleArticle = props => {
  const date = new Date(props.createdAt)
  const _date = {
    day: date.getUTCDate(),
    month: date.toLocaleString('en-US', { month: 'long' }),
    year: date.getUTCFullYear()
  }

  const _content = props.short
    ? `${props.content.slice(0, 400)}...`
    : props.content

  return (
    <Row className={css(style.main.wrapper)}>
      <Col xs='12' sm='3'>
        <Row>
          <Col
            className={`d-none d-sm-flex flex-column align-items-end ${css(
              style.date.wrapper
            )}`}
          >
            <span className={css(style.date.day)}>{_date.day}</span>
            <span className={css(style.date.date)}>
              {_date.month} {_date.year.toString().substring(2, 4)}
            </span>
          </Col>
        </Row>
        <hr className={css(style.main.spacer)} />
        <Row>
          <Col
            className={`d-none d-sm-flex justify-content-end align-items-center ${css(
              style.info.author
            )}`}
          >
            <i className={`fa fa-user`} />
            <span>&nbsp;by {props.author || 'Admin'} </span>
          </Col>
        </Row>
      </Col>
      <Col xs='12' sm='9'>
        <h3>
          <Link
            className={css(style.headers.h3)}
            to={`/dashboard/news/${props.seo}`}
          >
            {props.title}
          </Link>
        </h3>
        <p
          className={css(style.paragraphs.p)}
          dangerouslySetInnerHTML={{ __html: _content }}
        />
        {!props.short ? null : (
          <Link
            to={`/dashboard/news/${props.seo}`}
            className={css(style.info.more)}
          >
            Read more
          </Link>
        )}
      </Col>
    </Row>
  )
}

export default SingleArticle



// WEBPACK FOOTER //
// ./src/components/News/partials/SingleArticle/index.js